var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 18.7958C13.9755 18.7958 14.766 18.0052 14.766 17.03C14.766 16.0548 13.9755 15.2642 13.0002 15.2642C12.025 15.2642 11.2344 16.0548 11.2344 17.03C11.2344 18.0052 12.025 18.7958 13.0002 18.7958Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8046 10.3242V8.97008C19.8046 6.04508 19.1005 2.16675 13.0013 2.16675C6.90213 2.16675 6.19797 6.04508 6.19797 8.97008V10.3242C3.16464 10.7034 2.16797 12.2417 2.16797 16.0226V18.0376C2.16797 22.4792 3.52214 23.8334 7.9638 23.8334H18.0388C22.4805 23.8334 23.8346 22.4792 23.8346 18.0376V16.0226C23.8346 12.2417 22.838 10.7034 19.8046 10.3242ZM13.0013 20.3017C11.1921 20.3017 9.72963 18.8284 9.72963 17.0301C9.72963 15.2209 11.203 13.7584 13.0013 13.7584C14.7996 13.7584 16.273 15.2317 16.273 17.0301C16.273 18.8392 14.8105 20.3017 13.0013 20.3017ZM7.9638 10.2267C7.87713 10.2267 7.8013 10.2267 7.71463 10.2267V8.97008C7.71463 5.79591 8.6138 3.68341 13.0013 3.68341C17.3888 3.68341 18.288 5.79591 18.288 8.97008V10.2376C18.2013 10.2376 18.1255 10.2376 18.0388 10.2376H7.9638V10.2267Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3bd3518e8fb25d6df4ed98e4bb6e23a3.svg";
export { ForwardRef as ReactComponent };